import { PureComponent } from "react";
import { connect } from "react-redux";
import copy from "copy-to-clipboard";

import { UserDataAndState, isUserData } from "common/Database";
import { RootState } from "store/types";
import { LoadingIndicator } from "../orgs-styles";
import { makeNavBreadcrumbItems } from "../orgs-lib";
import NavBreadcrumb from "../breadcrumb/nav-breadcrumb";
import SectionHeader from "../section-header/section-header";
import { ReferralScreenContainer } from "./referral-screen-style";
import { Button } from "designer/ui/smart/button/button-style";

type Props = Readonly<{
    userData: UserDataAndState;
}>;

type State = Readonly<{
    copying: boolean;
}>;

function referralLinkForUserID(userID: string): string {
    return `https://glideapps.com/r/${userID}`;
}

class ReferralScreen extends PureComponent<Props, State> {
    state = { copying: false };

    private onCopyClick = () => {
        const { userData } = this.props;
        if (!isUserData(userData)) return;

        const referralLink = referralLinkForUserID(userData.id);
        this.setState({ copying: true });
        copy(referralLink);
        setTimeout(() => {
            this.setState({ copying: false });
        }, 1000);
    };

    public render() {
        const { userData } = this.props;
        const { copying } = this.state;
        if (!isUserData(userData)) return <LoadingIndicator />;
        const { referrals } = userData;

        const referralLink = referralLinkForUserID(userData.id);

        return (
            <ReferralScreenContainer className={"referral-nav"}>
                <NavBreadcrumb items={makeNavBreadcrumbItems("Referrals", "0", [])} />
                <SectionHeader name={"Referrals"} bold={true} />
                {referrals > 0 ? (
                    <div>
                        <p>
                            You have referred <strong>{referrals}</strong> active developer{referrals !== 1 ? "s" : ""},
                            unlocking an additional {100 * referrals} rows and {200 * referrals} sheet edits for your
                            free apps.
                        </p>
                        <p>Thank you for sharing Glide!</p>
                    </div>
                ) : (
                    <div>
                        <p>
                            Unlock an additional 100 rows and 200 sheet edits for your free apps for each{" "}
                            <em>active developer</em> you refer.
                        </p>{" "}
                        <p>
                            An <em>active developer</em> is anyone who publishes an app that is <em>actively used</em>{" "}
                            by one or more users each month. Referral credit lasts as long as your referral remains
                            active.
                        </p>
                    </div>
                )}
                <SectionHeader name="Your Referral Link" bold={false} />
                <div className={"referral-link-section"}>
                    <span>{referralLink}</span>
                    <Button disabled={copying} onClick={this.onCopyClick}>
                        {copying ? "Copied" : "Copy"}
                    </Button>
                </div>
            </ReferralScreenContainer>
        );
    }
}

const mapState = (state: RootState) => ({ userData: state.userData });
export default connect(mapState)(ReferralScreen);
